import { cn } from "@/lib/utils";

interface IBrowserFrameProps {
  /** Text shown in the frame's title bar, e.g. "Bubbles Place — Staff Hours". */
  label?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Browser-chrome card (traffic-light dots + label) used to frame product
 * screenshots throughout the redesigned marketing pages.
 */
export function BrowserFrame({
  label,
  children,
  className,
}: IBrowserFrameProps): React.ReactElement {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-[20px] border border-border bg-card shadow-xl",
        className
      )}
    >
      <div className="flex items-center gap-[7px] border-b border-border px-4 py-3">
        <span className="h-[11px] w-[11px] rounded-full bg-blush-rose-400" />
        <span className="h-[11px] w-[11px] rounded-full bg-apricot-cream-400" />
        <span className="h-[11px] w-[11px] rounded-full bg-mint-leaf-400" />
        {label && (
          <span className="ml-2.5 font-sans text-xs font-medium text-muted-foreground">
            {label}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}
